import axiosInstance from '../../../../../utils/axios';
import { handleErrorActivateMarginBoost } from './errors';

const cancelMarginBoost = async (
  marginBoostId: number,
  onSuccess: () => void,
  onError: () => void,
): Promise<void> => {
  try {
    const response = await axiosInstance.post(
      `/margin-boost/cancel/${marginBoostId}`,
    );
    if (response.status === 200) {
      onSuccess();
    }
  } catch (error) {
    handleErrorActivateMarginBoost(error, onError);
    throw error;
  }
};

export default cancelMarginBoost;
